module.exports = "<div class=\"loader\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/loader/loader.component.html
// module id = ./src/app/components/shared/loader/loader.component.html
// module chunks = main